import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
import { DeviceStopItem } from '@/services/telemetry/interface';
import { VehicleMarkerItem, NavigationData } from './interfaces';

@Module({ namespaced: true })
export class VehicleMonitoring extends VuexModule {
  public vehiclesMarkersItems: VehicleMarkerItem[] = [];

  @Mutation
  public unsetVehiclesMarkers(): void {
    this.vehiclesMarkersItems = [];
  }

  @Mutation
  public addVehicleMarker(marker: VehicleMarkerItem): void {
    this.vehiclesMarkersItems.push(marker);
  }

  @Mutation
  public updateVehicleMarker({ deviceId, value }: NavigationData): void {
    this.vehiclesMarkersItems = this.vehiclesMarkersItems.map(m => {
      if (m.deviceId === deviceId) {
        return {
          ...m,
          deviceId,
          position: [value.latitude, value.longitude],
          direction: value.direction,
          lastUpdateTime: +(Date.now() / 1000).toFixed(0),
        };
      }

      return m;
    });
  }

  @Mutation
  public updateVehicleMarkerStops({ deviceId, stops }: {deviceId: number, stops: DeviceStopItem[]}): void {
    this.vehiclesMarkersItems = this.vehiclesMarkersItems.map(m => ({
      ...m,
      stops: m.deviceId === deviceId ? stops : [],
    }));
  }

  @Mutation
  public setIsLoadingMarkerRoute({ deviceId, isLoadingRoute }: {deviceId: number, isLoadingRoute: boolean}): void {
    this.vehiclesMarkersItems = this.vehiclesMarkersItems.map(m => {
      if (m.deviceId === deviceId) {
        return {
          ...m,
          isLoadingRoute,
        };
      }

      return m;
    });
  }

  @Mutation
  public setIsTrackEmulation({ deviceId, isTrackEmulation }: {deviceId: number, isTrackEmulation: boolean}): void {
    this.vehiclesMarkersItems = this.vehiclesMarkersItems.map(m => ({
      ...m,
      isTrackEmulation: m.deviceId === deviceId ? isTrackEmulation : false,
    }));
  }

  @Mutation
  public removeVehicleMarker(deviceId: number): void {
    this.vehiclesMarkersItems = this.vehiclesMarkersItems.filter(m => m.deviceId !== deviceId);
  }
}
